import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { AppConstants } from 'src/app/core/constants/appconstants';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/core/services/api.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ServiceExportExcel } from 'src/app/core/services/export.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { MatTableDataSource } from '@angular/material/table';
import Swal from 'sweetalert2';

export interface PeriodicElement {
  id: number;
  landmark: string;
  latitude: number;
  longitude: number;
  type: string;
}

@Component({
  selector: 'app-fixed-routing-setup',
  templateUrl: './fixed-routing-setup.component.html',
  styleUrls: ['./fixed-routing-setup.component.scss']
})

export class FixedRoutingSetupComponent implements OnInit {

  public _mFormGroup: FormGroup;
  public mCity = new FormControl('', Validators.required);
  public mSite = new FormControl('', Validators.required);
  public mRouteType = new FormControl('');

  displayedColumns: string[] = ['landmark', 'latitude', 'longitude', 'type', 'id'];
  _mRouteTypes: any[] = [{ key: "All", value: "All" }, { key: "P", value: "Primary" }, { key: "C", value: "Combined" }, { key: "FC", value: "Fully Combined" }];
  addFlag: boolean = false;
  ELEMENT_DATA: PeriodicElement[] = [];
  landMarkData: any[] = [];
  dataSource = new MatTableDataSource<PeriodicElement>(this.ELEMENT_DATA);
  mRouteSearchKey: any = '';
  mAreaSearchKey: any = '';
  mLandmarkSearchKey: any = '';
  _mSites: any = [];
  _mCities: any = [];
  _mSelectedCityFlag: boolean = false;
  errorResult = [];
  routesFile: string;
  _mTempRouteId: any;
  _mTempAreaId: any;
  _mRoutesData: any[] = [];
  _mTempRoutesData: any[] = [];
  _mAreasData: any[] = [];
  _mTempAreasData: any[] = [];
  routingData: any;


  constructor(
    private fb: FormBuilder,
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    private readonly serviceExportExcel: ServiceExportExcel,
    private readonly localStorage: ServiceLocalStorage,
    public readonly dialog: MatDialog,
    private ngxLoader: NgxUiLoaderService
  ) {
    this._mFormGroup = this.fb.group({
      'city': this.mCity,
      'site': this.mSite,
      'routeType': this.mRouteType
    });
  }

  ngOnInit() {
    this.loadCities();
  }

  loadCities() {
    const companyId = +this.localStorage.getCompanyId();
    this.apiService.doGetRequestWithResponse(ApiConstants.getLocationsByCompanyIdAndUser + companyId, success => {
      if (success.status == 200) {
        this._mCities = success.body;
        // Prefill City with first available when page loads
        if (!this.mCity.value && this._mCities && this._mCities.length > 0) {
          const firstCity = this._mCities[0];
          this.mCity.setValue(firstCity.locationId || firstCity.id || '');
          // Set selectedCity and load sites for the selected location
          this.getSitesByCityId();
        }
      } else {
        this._mCities = [];
        this.notifyService.showInfo("No data found", null);
      }
    }, (error) => {
    });
  }

  getSitesByCityId() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getserchsitelist + this.mCity.value, success => {
      if (success.status == 200) {
        this._mSites = success.body;
        if (this._mSites.length > 0) {
          this._mFormGroup.get('site').setValue(this._mSites[0].siteId);
          this._mFormGroup.get('routeType').setValue(this._mRouteTypes[0].key);
        }
      } else {
        this._mSites = [];
        this.notifyService.showInfo("No Sites Found!", null);
      }
    },
      error => {
      }
    );
  }

  routeSearch($event) {
    let searchValue = $event.target.value;
    if (searchValue) {
      this._mRoutesData = this._mTempRoutesData.filter(route => route.routeName.toLowerCase().includes(searchValue.toLowerCase()));
    }
  }

  areaSearch($event) {
    let searchValue = $event.target.value;
    if (searchValue) {
      this._mAreasData = this._mTempAreasData.filter(area => area.area.toLowerCase().includes(searchValue.toLowerCase()));
    }
  }

  landmarkSearch($event) {
    let searchValue = $event.target.value;
    if (searchValue) {
      this.dataSource = new MatTableDataSource<PeriodicElement>(this.ELEMENT_DATA.filter(landmark => landmark.landmark.toLowerCase().includes(searchValue.toLowerCase())))
    }
  }

  getAreaByRouteId(routeId) {
    this._mTempRouteId = routeId;
    this.apiService.doGetRequestWithResponse(ApiConstants.getAreaByRouteId + '?routeid=' + routeId, (success) => {
      if (success.status == 200) {
        this._mAreasData = success.body;
        this._mTempAreasData = success.body;
      } else {
        this._mAreasData = [];
        this._mTempAreasData = [];
        this.notifyService.showInfo("No data found", null);
      }
    }, (error) => {
      this.notifyService.showError(error.message, null);
    })
  }

  getLandmarkByAreaId(areaId) {
    this._mTempAreaId = areaId;
    this.apiService.doGetRequestWithResponse(ApiConstants.getLandmarksByAreaId + '?areaid=' + areaId + '&routeid=' + this._mTempRouteId, (success) => {
      if (success.status == 200) {
        this.ELEMENT_DATA = success.body;
        this.landMarkData = success.body
        this.dataSource = new MatTableDataSource<PeriodicElement>(this.ELEMENT_DATA);
      } else {
        this.ELEMENT_DATA = [];
        this.landMarkData = [];
        this.dataSource.data = [];
        this.notifyService.showInfo("No data found", null);
      }
    }, (error) => {
      this.notifyService.showInfo(error.message, null);
    })
  }

  onDownloadAL() {
    if (!this.mSite.value) {
      this.notifyService.showWarning("please select site", null);
      return;
    }

    this.apiService.doGetRequestWithResponse(
      `${ApiConstants.getalllandmarksbylocation}${this.mCity.value}&type=${AppConstants.LANDMARK_TYPE_COMMON}`,
      (success) => {
        if (success.status === 200) {
          const fileData = success.body.map(element => ({
            Area: element.area.area,
            Landmark: element.landmark,
            FormattedAddress: element.formattedAddress,
            Latitude: element.latitude,
            Longitude: element.longitude,
            Type: element.type
          }));
          this.serviceExportExcel.exportAsExcelFile(fileData, 'AL');
        }
      },
      (error) => console.log(error)
    );
  }

  onDownloadHAL() {
    if (!this.mSite.value) {
      this.notifyService.showWarning("please select site", null);
      return;
    }

    this.apiService.doGetRequestWithResponse(
      `${ApiConstants.getalllandmarksbylocation}${this.mCity.value}&type=${AppConstants.LANDMARK_TYPE_HOME}`,
      (success) => {
        if (success.status === 200) {
          const fileData = success.body.map(element => ({
            Area: element.area.area,
            Landmark: element.landmark,
            FormattedAddress: element.formattedAddress,
            Latitude: element.latitude,
            Longitude: element.longitude,
            Type: element.type
          }));
          this.serviceExportExcel.exportAsExcelFile(fileData, 'AL');
        }
      },
      (error) => console.log(error)
    );
  }

  downloadRouteTemplate() {
    if (!this.mSite.value) {
      this.notifyService.showWarning("please select site", null);
      return;
    }

    this.apiService.doGetRequestWithResponse(
      ApiConstants.getFixedRouteTemplate,
      (success) => {
        if (success.status === 200) {
          const bin = atob(success.body.template);
          const ab = this.s2ab(bin);
          const blob = new Blob([ab], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = 'RouteTemplate.xlsx';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      },
      (error) => this.notifyService.showError(error.body.error, null)
    );
  }

  downloadRoutes() {
    if (!this.mSite.value) {
      this.notifyService.showWarning("please select site", null);
      return;
    }

    this.apiService.doGetRequestWithResponse(
      `${ApiConstants.getRoutes}?siteid=${this.mSite.value}`,
      (success) => {
        if (success.status === 200) {
          const bin = atob(success.body.downloadroutes);
          const ab = this.s2ab(bin);
          const blob = new Blob([ab], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = 'Routes.xlsx';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      },
      (error) => this.notifyService.showError(error.body.error, null)
    );
  }

  s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }

  onFileChange($event) {
    const files = $event.target.files;
    if (!this.mSite.value) {
      this.notifyService.showWarning("Please Select Site", null);
      return;
    }

    if (!files || files.length === 0) return;
    const fileType = files[0].type;
    if (!fileType || !fileType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      this.ngxLoader.stop();
      this.routesFile = "";
      this.notifyService.showWarning("There seems to be a problem with the file that you uploaded. Please upload a Valid File", null);
      return;
    }

    this.routesFile = "";
    const formdata = new FormData();
    formdata.append('file', files[0]);
    formdata.append('siteid', this.mSite.value);
    this.ngxLoader.start();
    this.apiService.doPostFile(
      ApiConstants.uploadRoutes,
      formdata,
      (success) => {
        this.ngxLoader.stop();
        this.errorResult = success;
        if (this.errorResult.length === 0) {
          this.notifyService.showSuccess("Routes Uploaded Successfully", null);
        } else {
          this.notifyService.showSuccess(`Routes Upload Completed with ${this.errorResult.length} errors...`, null);
          const errorData = this.errorResult.join("\r\n");
          this.expFile(errorData);
        }
      },
      (error) => this.ngxLoader.stop()
    );
  }

  expFile(data) {
    var fileText = data;
    var fileName = "routesUploadErrors.txt"
    this.saveTextAsFile(fileText, fileName);
  }

  saveTextAsFile(data, filename = 'console.json') {
    if (!data) {
      console.error('Console.save: No data');
      return;
    }

    const blob = new Blob([data], { type: 'text/plain' });
    const nav = window.navigator as any;
    if (nav?.msSaveOrOpenBlob) {
      nav.msSaveOrOpenBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      link.download = filename;
      link.href = window.URL.createObjectURL(blob);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  onSubmit() {
    if (!this._mFormGroup.valid) return;
    this._mAreasData = [];
    this._mTempAreasData = [];
    this.ELEMENT_DATA = [];
    this.dataSource = new MatTableDataSource<PeriodicElement>(this.ELEMENT_DATA);
    this.apiService.doGetRequestWithResponse(
      `${ApiConstants.getroutebysiteidandtype}${this.mSite.value}&type=${this.mRouteType.value}`,
      (success) => {
        if (success.status === 200) {
          this._mRoutesData = success.body;
          this._mTempRoutesData = success.body;
        } else {
          this._mRoutesData = [];
          this._mTempRoutesData = [];
          this.notifyService.showInfo("No data found", null);
        }
      },
      (error) => { }
    );
  }

  onAdd() {
    if (!this.mSite.valid) {
      this.notifyService.showWarning('please select site for adding route', null);
      return;
    }

    this.routingData = {
      siteId: this.mSite.value,
      cityId: this.mCity.value,
    };
    this.addFlag = true;
  }

  onDelete(element, type) {
    let msgKey = AppConstants.DELETE_MSG;
    const typeMap = {
      landmark: element.landmark,
      area: element.area,
      route: element.routeName
    };
    const msg = `Are you sure want to Delete - ${typeMap[type]}?`;
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger ms-2'
      },
      buttonsStyling: false
    });
    swalWithBootstrapButtons.fire({
      title: msg,
      text: msgKey,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonColor: '#34c38f',
      cancelButtonColor: '#f46a6a',
    }).then(result => {
      if (result.value) {
        swalWithBootstrapButtons.fire('Done', msgKey, 'success');
        this.onStatusToggled(element, type);
      }
    })
  }

  // onStatusToggled(element, type) {
  //   if (type == "landmark") {
  //     this.apiService.doPostRequestWithResponse(ApiConstants.deletelandmarkfromroute + '?routeid=' + this._mTempRouteId + '&areaid=' + this._mTempAreaId + '&landmarkid=' + element.id, '', (success) => {
  //       if (success.status == 200) {
  //         this.ELEMENT_DATA = success.body;
  //         this.dataSource = new MatTableDataSource<PeriodicElement>(this.ELEMENT_DATA);
  //         this.notifyService.showSuccess("Deleted successfully", null);
  //       }
  //     }, (error) => {
  //     });
  //   } else if (type == "area") {
  //     this.apiService.doPostRequestWithResponse(ApiConstants.deleteareafromroute + '?routeid=' + this._mTempRouteId + '&areaid=' + this._mTempAreaId, '', (success) => {
  //       if (success.status == 200) {
  //         this._mAreasData = success.body;
  //         this._mTempAreasData = success.body;
  //         this.ELEMENT_DATA = [];
  //         this.dataSource = new MatTableDataSource<PeriodicElement>(this.ELEMENT_DATA);
  //         this.notifyService.showSuccess("Deleted successfully", null);
  //       }
  //     }, (error) => {
  //     })
  //   } else if (type == "route") {
  //     this.apiService.doPostRequestWithResponse(ApiConstants.deleteroutebyrouteid + this.mSite.value + '&routeid=' + this._mTempRouteId, '', (success) => {
  //       if (success.status == 200) {
  //         this._mRoutesData = success.body;
  //         this._mTempRoutesData = success.body;
  //         this._mAreasData = [];
  //         this._mTempAreasData = [];
  //         this.ELEMENT_DATA = [];
  //         this.dataSource = new MatTableDataSource<PeriodicElement>(this.ELEMENT_DATA);
  //         this.notifyService.showSuccess("Deleted successfully", null);
  //       }
  //     }, (error) => {
  //     })
  //   }
  // }

  onStatusToggled(element: any, type: 'landmark' | 'area' | 'route') {
    const urlMap: any = {
      landmark: `${ApiConstants.deletelandmarkfromroute}?routeid=${this._mTempRouteId}&areaid=${this._mTempAreaId}&landmarkid=${element.id}`,
      area: `${ApiConstants.deleteareafromroute}?routeid=${this._mTempRouteId}&areaid=${this._mTempAreaId}`,
      route: `${ApiConstants.deleteroutebyrouteid}${this.mSite.value}&routeid=${this._mTempRouteId}`
    };

    this.apiService.doPostRequestWithResponse(urlMap[type], '', (success) => {
      if (success.status === 200) {
        if (type === 'landmark') {
          this.getLandmarkByAreaId(this._mTempAreaId);
        } else if (type === 'area') {
          this.getAreaByRouteId(this._mTempRouteId);
          this.ELEMENT_DATA = [];
          this.dataSource = new MatTableDataSource<PeriodicElement>(this.ELEMENT_DATA);
        } else if (type === 'route') {
          this.onSubmit();
          this.ELEMENT_DATA = [];
          this.dataSource = new MatTableDataSource<PeriodicElement>(this.ELEMENT_DATA);
        }
        this.notifyService.showSuccess(success.body.message, null);
      }
    }, (error) => {
      console.error(error);
    });
  }

  getParentNode(element) {
    return element.closest('.main_li');
  }

  hoverFunction($event) {
    this.getParentNode($event.target)?.querySelector('.fr_list_icons')?.classList.add('showBtn-FR');
  }

  hoverOutFunction($event) {
    this.getParentNode($event.target)?.querySelector('.fr_list_icons')?.classList.remove('showBtn-FR');
  }

}